import { createSlice } from "@reduxjs/toolkit";
import { sagaActions } from "../sagas/sagaActions";

const initialState = {
  lookups: {},
};

export const homeLookupsSlice = createSlice({
  name: "homeLookups",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(sagaActions.HOME_LOOKUPS_LOAD, (state, action) => {
      state.lookups = action.data;
    });
  },
});

export default homeLookupsSlice.reducer;
